module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-select', {
    ref: "select",
    attrs: {
      "items": _vm.options,
      "item-text": "Name",
      "item-value": "value",
      "outlined": "",
      "hide-details": "true",
      "label": "Day",
      "id": "dayOfWeek_ddl"
    },
    on: {
      "input": function (val) { return _vm.$emit('input', val); }
    },
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-140390d4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/appComponents/targets/components/DayOfWeekDDL.vue
// module id = 1816
// module chunks = 0